import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#EBEBEB",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#006FCF",
  "fill-rule": "evenodd",
  d: "M47.004 6.032h-4.111l-2.15 6.168-2.242-6.168h-4.205v9.603l-4.298-9.603H26.54l-4.298 9.812h2.99l.84-1.963h4.486l.84 1.963h5.607V9.021l2.523 6.822h2.336l2.523-6.822v6.822h2.616v1.495h-3.457l-2.803 3.083-2.897-3.084H25.98v9.812h11.774l2.896-3.177 2.897 3.177h3.457v1.214h-4.111l-2.243-2.43-2.243 2.43H24.485V17.152H20l5.606-12.615h5.42l1.962 4.299V4.537h6.728l1.12 3.27 1.122-3.27h5.046zm0 13.456-2.523 2.71 2.523 2.709v2.243l-4.579-4.953 4.579-4.858zM34.296 27.15v-2.336H28.69v-1.495h5.513v-2.243H28.69v-1.495h5.606V17.34l4.672 4.858-4.672 4.953Zm-7.382-15.418 1.309-3.177 1.308 3.177z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }